<template>
  <div class="back">
    <div class="return" @click="login">
      返回登录 <img src="@/assets/img/return.png" alt="" />
    </div>
    <div class="bodyBox">
      <div class="tab" @click="loginType = 1">忘记密码</div>
      <div class="typeCont">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          class="ruleForm"
          label-position="top"
        >
          <el-form-item prop="phone" label="联系人手机" class="mt20">
            <el-input
              v-model="form.phone"
              type="text"
              placeholder="请输入联系人手机"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="captcha" label="验证码">
            <div style="position: relative">
              <el-input v-model="form.captcha" placeholder="请输验证码">
              </el-input>
              <SendCode
                :mobile="form.phone"
                type="resetPassword"
                style="
                  z-index: 999;
                  font-size: 14px;
                  color: #2b86eb;
                  cursor: pointer;
                  top: 0;
                  right: 20px;
                  position: absolute;
                "
                >发送验证码
              </SendCode>
            </div>
          </el-form-item>
          <el-form-item prop="password" label="输入密码">
            <el-input
              v-model="form.password"
              placeholder="请输入密码"
              type="password"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="password_a" label="确认密码">
            <el-input
              v-model="form.password_a"
              placeholder="请再次确认密码"
              type="password"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-button class="loginBtn" @click="submitPsw()">确 定</el-button>
    </div>
  </div>
</template>

<script>
import SendCode from "@/components/common/SendCode";
import { forgotPassword } from "@/api";

export default {
  name: "password",
  components: {
    SendCode,
  },
  data() {
    const validatePass1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (this.form.password !== this.form.password_a) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      loginType: 1, // 登录方式
      form: {
        phone: "", // 手机号
        captcha: "", // 验证码
        password: "", // 密码
        password_a: "", // 再次确认密码
      },
      rules: {
        phone: [
          { required: true, message: "请输入联系人手机", trigger: "blur" },
        ],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "密码长度在6-20位之间",
            trigger: "blur",
          },
        ],
        password_a: [
          { required: true, message: "请再次确认密码", trigger: "blur" },
          { validator: validatePass1, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    // this.init();
  },
  methods: {
    // 发送短信验证码
    // async sendCode() {
    //   if (this.params.mobile) {
    //     try {
    //       await user.sendSMS(this.params.mobile, 'register')
    //     } catch (error) {
    //       this.$notify.error({
    //         title: '错误',
    //         message: error.toString(),
    //       })
    //     }
    //   }
    // },

    // 忘记密码
    async submitPsw() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          delete this.form.password_a;
          // console.log(this.form, "delete");
          const res = await forgotPassword(this.form);
          // console.log(res, "res");
          this.$message.success("密码修改成功！");
          this.$store.commit("setUserInfo", res);
          this.$router.push({ name: "login" });
        } else {
          return false;
        }
      });
    },
    login() {
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style lang="less" scoped>
body {
  background: #f7f8fc;
}

.back {
  background: #fff;
  width: 770px;
  margin: auto;
  margin-top: 40px;
  padding: 57px 195px;
  box-sizing: border-box;
  position: relative;

  .return {
    cursor: pointer;
    position: absolute;
    right: 30px;
    top: 64px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: #4379f6;

    img {
      width: 12px;
      height: 10px;
      margin-left: 3px;
    }
  }

  .bodyBox {
    position: relative;

    .scan {
      position: absolute;
      top: 0;
      right: 0;
      width: 41px;
      height: 41px;
    }

    .tab {
      font-size: 24px;
      font-weight: 700;
      text-align: center;
      color: #333333;
      display: flex;
      justify-content: center;
    }

    .checkControll {
      display: flex;
      width: 100%;

      /deep/ .el-radio__input.is-checked .el-radio__inner {
        border-color: #2f60ed;
        background: #2f60ed;
      }

      /deep/ .el-radio__input.is-checked + .el-radio__label {
        color: #2f60ed;
      }

      /deep/ .el-radio.is-bordered.is-checked {
        border-color: #2f60ed;
      }

      .selectItem {
        flex: 1;
        text-align: center;
      }

      /deep/ .el-radio.is-bordered {
        border-radius: unset;
        margin-left: unset;
      }
    }

    /deep/ .el-select {
      width: 100%;
    }

    /deep/ .el-form-item {
      margin-bottom: 10px;
    }

    .typeCont {
      margin-top: 30px;

      .mt20 {
        margin-top: 10px;
      }

      /deep/ .el-input__icon {
        width: 42px;
      }

      /deep/ .el-input--prefix .el-input__inner {
        padding-left: 42px;
        background: #f6f6f6;
        border: 1px solid #f6f6f6;
      }

      /deep/
        .el-form-item.is-required:not(.is-no-asterisk)
        > .el-form-item__label:before {
        color: #fff;
        margin-right: unset;
        content: "";
      }

      /deep/ .el-form-item__label {
        line-height: unset;
        margin-bottom: 10px;
      }
    }

    .loginBtn {
      width: 100%;
      height: 45px;
      background: #4379f6;
      border-radius: 2px;
      box-shadow: 0px 3px 6px 0px rgba(67, 121, 246, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular, sans-serif;
      color: #fff;
      margin-top: 23px;
      transition: all 0.3s;

      &:hover {
        background: #316bf1;
      }
    }

    .help {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 15px;

      .psw {
        min-width: 70px;
        border: 1px solid rgba(0, 0, 0, 0);
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular, sans-serif;
        color: #999;
        cursor: pointer;
      }

      .register {
        min-width: 56px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular, sans-serif;
        color: #2f60ed;
        cursor: pointer;
      }
    }

    .letter {
      padding-top: 41px;
      display: flex;
      justify-content: center;
      font-size: 12px;
      font-family: PingFang SC, PingFang SC-Regular, sans-serif;
      color: #999;
    }

    .scanLogin {
      width: 190px;
      height: 190px;
      background: #ddd;
      margin: auto;
      margin-top: 27px;
    }

    .goCont {
      width: 100%;
      display: flex;
      justify-content: center;

      .goRegister {
        margin-top: 35px;
        width: 56px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular, sans-serif;
        color: #2f60ed;
        cursor: pointer;
      }
    }
  }
}

/deep/ .el-form-item__label {
  margin-bottom: unset !important;
}

/deep/ .el-form-item {
  margin-bottom: 30px !important;
}
</style>
